import KODIAK_FARM_ABI from 'abis/KodiakFarm.json'
import { WAGMI_REFETCH_POLICY_NEVER } from 'config/RefetchPolicies'
import { useConnection } from 'hooks/useConnection'
import { useMemo } from 'react'
import type { Abi } from 'viem'
import { Address } from 'viem'
import { useReadContract } from 'wagmi'

export function useIsFarmAdmin(farmAddress: Address) {
  const { account } = useConnection()

  const { data: owner, isLoading } = useReadContract({
    address: farmAddress,
    abi: KODIAK_FARM_ABI as Abi,
    functionName: 'owner',
    query: {
      ...WAGMI_REFETCH_POLICY_NEVER,
      enabled: !!farmAddress,
    },
  })

  const isAdmin = useMemo(() => {
    if (!account || !owner) return false
    return (owner as string).toLowerCase() === account.toLowerCase()
  }, [account, owner])

  return { isAdmin, loading: isLoading }
}
